/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LogDto } from '../../models/log-dto';
import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface AdminControllerFindLogs$Params {
  id: string;

/**
 * 페이지 크기
 */
  pageSize?: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 모델명
 */
  modelName?: 'Admin' | 'AdminLog' | 'AlimTalkLog' | 'BackgroundTaskLog' | 'Banner' | 'BoothApplication' | 'BoothOptionTemplate' | 'BoothOption' | 'BroadcastSchedule' | 'Company' | 'DonationGallery' | 'Event' | 'Exhibitor' | 'Faq' | 'File' | 'FloorPlan' | 'Booth' | 'Gallery' | 'HeroBanner' | 'History' | 'Inquiry' | 'KioskConfig' | 'Log' | 'MarketingConsent' | 'News' | 'Notice' | 'Place' | 'Policy' | 'Popup' | 'PreRegistration' | 'Setting' | 'Sponsor' | 'Task' | 'Visitor';

/**
 * 모델명 목록
 */
  modelNames?: Array<'Admin' | 'AdminLog' | 'AlimTalkLog' | 'BackgroundTaskLog' | 'Banner' | 'BoothApplication' | 'BoothOptionTemplate' | 'BoothOption' | 'BroadcastSchedule' | 'Company' | 'DonationGallery' | 'Event' | 'Exhibitor' | 'Faq' | 'File' | 'FloorPlan' | 'Booth' | 'Gallery' | 'HeroBanner' | 'History' | 'Inquiry' | 'KioskConfig' | 'Log' | 'MarketingConsent' | 'News' | 'Notice' | 'Place' | 'Policy' | 'Popup' | 'PreRegistration' | 'Setting' | 'Sponsor' | 'Task' | 'Visitor'>;

/**
 * 모델 ID
 */
  modelId?: string;

/**
 * 모델 ID
 */
  modelIds?: Array<string>;
}

export function adminControllerFindLogs(http: HttpClient, rootUrl: string, params: AdminControllerFindLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LogDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, adminControllerFindLogs.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('modelName', params.modelName, {});
    rb.query('modelNames', params.modelNames, {});
    rb.query('modelId', params.modelId, {});
    rb.query('modelIds', params.modelIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto & {
      'items'?: Array<LogDto>;
      }>;
    })
  );
}

adminControllerFindLogs.PATH = '/api/admins/{id}/logs';
